import { useLocales } from 'src/locales';
import ContactUs from '../../contact-us/contact-us';

const ContactUsView = () => {
  const { t } = useLocales();
  return <ContactUs title={t('statistics.contactUs.title')} />;
};

export default ContactUsView;
